export default __webpack_public_path__ + "static/media/doubleCard.93b3760b.svg";